const styles = theme => ({
  root: {
    position: 'relative',
    display: 'block',
    margin: [0, 'auto', 10],
    width: '100%'
  },
  svg: {
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0
  },
  path: {
    opacity: ({ energy }) => energy.animate ? 0 : 1
  },
  content: {
    position: 'relative',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    margin: [0, 'auto'],
    padding: [20, 20, 10],
    width: '100%',
    maxWidth: 1000
  },
  brandRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 8,
    width: '100%'
  },
  brand: {
    margin: [0, 'auto', 10],
    width: 'auto',
    height: 28.35
  },
  siteName: {
    fontFamily: '"Bungee", sans-serif',
    color: theme.color.heading.main,
    textShadow: `0 0 5px ${theme.color.secondary.main}`,
    fontSize: 31.35,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    letterSpacing: 1,
    margin: [10, 'auto', 15],
    textAlign: 'center'
  },
  navRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
    width: '100%'
  },
  menu: {
    width: '100%'
  },
  languageSwitcher: {
    marginTop: 6
  },

  '@media screen and (min-width: 768px)': {
    root: {
      marginBottom: 20
    },
    content: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 16,
      padding: [20, 20, 30]
    },
    brandRow: {
      flexDirection: 'row',
      alignItems: 'center',
      width: 'auto',
      gap: 10
    },
    brand: {
      margin: 0,
      width: 'auto',
      height: 34.05
    },
    siteName: {
      margin: [0, 16, 0, 12],
      fontSize: 37.05,
      textAlign: 'left'
    },
    navRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 14,
      width: '100%'
    },
    menu: {
      margin: [0, 0, 0, 'auto'],
      maxWidth: 'none',
      flex: 1
    },
    languageSwitcher: {
      marginTop: 0
    }
  },

  '@media screen and (min-width: 1025px)': {
    menu: {
      margin: 0,
      width: 'auto',
      maxWidth: 'none',
      flex: 1
    }
  }
});

export { styles };
